import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const UploadIndicados = Loadable({
   loader: () => import('../views/Conformidade/UploadIndicados'),
   loading: RouteLoading,
});

const AvaliacaoConformidade = Loadable({
  loader: () => import('../views/Conformidade/AvaliacaoConformidade'),
  loading: RouteLoading,
});

const AvaliacaoConformidadeFormulario = Loadable({
  loader: () => import('../views/Conformidade/AvaliacaoConformidade/Avaliacao'),
  loading: RouteLoading,
});

const AvaliacaoConformidadePDF = Loadable({
  loader: () => import('../views/Conformidade/AvaliacaoConformidade/Avaliacao/PDFViewer'),
  loading: RouteLoading,
});

const FormulariosConformidade = Loadable({
  loader: () => import('../views/Conformidade/Formularios'),
  loading: RouteLoading,
});

const NovoFormularioConformidade = Loadable({
  loader: () => import('../views/Conformidade/Formularios/Formulario'),
  loading: RouteLoading,
});

const RelatorioConformidade = Loadable({
  loader: () => import('../views/Conformidade/RelatorioConformidade'),
  loading: RouteLoading,
});

const DashboardConformidade = Loadable({
  loader: () => import('../views/Conformidade/Dashboard'),
  loading: RouteLoading,
});

const Prazos = Loadable({
  loader: () => import('../views/Conformidade/Prazos'),
  loading: RouteLoading,
});

const RouteConformidade = [
  {
    path: '/conformidade/avaliacao',
    exact: true,
    name: '',
    component: AvaliacaoConformidade,
  },
  {
    path: '/conformidade/avaliacao/:numeroContrato',
    exact: true,
    name: 'Avaliação de Conformidade',
    component: AvaliacaoConformidadeFormulario,
  },
  {
    path: '/conformidade/pdf/:numeroContrato',
    exact: true,
    name: 'Avaliação de Conformidade',
    component: AvaliacaoConformidadePDF,
  },
  {
    path: '/conformidade/upload',
    exact: true,
    name: 'Upload de Indicados',
    component: UploadIndicados,
  },
  {
    path: '/conformidade/formulario',
    exact: true,
    name: 'Parametrização / Formulário',
    component: FormulariosConformidade,
  },
  {
    path: '/conformidade/formulario/novo/:IdParametrizacaoConformidade',
    exact: true,
    name: 'Editar Formulário',
    component: NovoFormularioConformidade,
  },
  {
    path: '/conformidade/formulario/novo',
    exact: true,
    name: 'Novo Formulário',
    component: NovoFormularioConformidade,
  },
  {
    path: '/conformidade/relatorios',
    exact: true,
    name: 'Relatórios',
    component: RelatorioConformidade,
  },
  {
    path: '/conformidade/dashboard',
    exact: true,
    name: 'Dashboard',
    component: DashboardConformidade,
  },
  {
    path: '/conformidade/prazos',
    exact: true,
    name: 'Parametrização / Prazo',
    component: Prazos,
  },
];

export { RouteConformidade };
